import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure33 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'column',
      height: '600px',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
          fontFamily: 'Montserrat'
      }
  },
  credits: {
      enabled: false
  },
  title: {
      text: null
  },
  subtitle: {
      text: null
  },
  plotOptions: {
      series: {
          borderWidth: 0,
          stacking: 'normal',
      }
  },
  exporting: {
      enabled: false
  },
  xAxis: [{
      tickWidth: 0,
      categories: [
          {
              name: "Monde",
              categories: ["2017","2018","2019", "2020",]
          },
          {
            name: "",
            categories: ['']  
          },
          {
              name: 'Amérique du Nord <br /> et Europe',
              categories: ["2017","2018","2019", "2020"]
          },
          {
              name: "",
              categories: [''] 
          },
          {
              name: "Amérique Latine <br /> et Caraïbes",
              categories: ["2017", "2018","2019", "2020"]
          },
             {
              name: "",
              categories: [''] 
          },
          {
              name: "Asie centrale <br /> et Asie du Sud",
              categories: ["2017", "2018","2019", "2020"]
          },
             {
              name: "",
              categories: [''] 
          },
          {
              name: "Asie de l’Est <br /> et Asie du Sud-Est",
              categories: ["2017", "2018","2019", "2020"]
          },
             {
              name: "",
              categories: [''] 
          },
          {
              name: "Asie de l’Ouest <br /> et Afrique du Nord",
              categories: ["2017", "2018","2019", "2020"]
          },
             {
              name: "",
              categories: [''] 
          },
          {
              name: "Afrique subsaharienne",
              categories: ["2017", "2018","2019", "2020"]
          },
             {
              name: "",
              categories: [''] 
          },
          {
              name: "Pays en développement <br /> sans littoral (PDSL)",
              categories: ["2017", "2018","2019", "2020"]
          },
             {
              name: "",
              categories: [''] 
          },
          {
              name: "Pays les moins avancés (PMA)", 
              categories: ["2017", "2018","2019", "2020"]
          },
      ],
      tickLength: 0,
      labels: {
        align: 'center',
          rotation: 270,
          tickLength: 15,

      },
      lineWidth: 0,
      fontsize: '2px',
      /*tickWidth: 0*/
    },
    ],
    labels: {
            //     reserveSpace: true,
            //     groupedOptions: [
            //         {
            //             rotation: 0,
            //             style: {transform: 'unset', 'transform-origin': '74% 12px', 'padding-right': '16px'},
            //         }
            //         ],
              //   rotation: -90,
            //     useHTML: true,
            //     style: {
            //         transform: 'rotate(-90deg)',
            //         'transform-origin': '50% 11px',
            //         width: 'unset',
            //         'padding-right': '42px',
            //         overflow: 'visible'
            //     },
             },

  yAxis: [{
      labels: {
          style: {
              fontWeight: 'normal',
              color: '#999999',
              fontSize: '12px'
          },
      },
      	format: '{value}',
      gridLineWidth: 2,
      floor: 0,
      ceiling: 70,
      tickInterval: 10,
      title: {
          text: '',
          style: {
              color: Highcharts.getOptions().colors[1]
          }
      }
  }],
  tooltip: {
      shared: true,
      useHTML: true,
      hideDelay: 500,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      valueSuffix: '%',
      style: {
          padding: 0
      }
  },
  legend: {
      enabled: false,
  },
  series: [ {
    name: 'Prix alimentaires modérément élevés',
    color: '#ed7d31',
    data: [ 4, 2, 7, 21, null,
      9, 9, 9, 22, null,
      0, 0, 7.9, 16,null,
      0, 0, 8, 50, null,
      7, 0, 7, 13, null,
      9, 9, 9, 22, null,
      5, 5, 6.8, 11, null,
      7, 4, 11, 18, null,
      5, 2, 9.8, 15, 
           ]
},
    {
      name: 'Prix alimentaires anormalement élevés',
      color: '#5b9bd5',
      data: [ 
             10, 3, 9, 26, null,
             13, 0, 13, 22, null,
             3, 5, 7.9, 32, null,
             25, 17, 8, 17, null,
             0, 7, 7, 20, null,
             13, 0, 13, 22, null,
             5, 0, 2.3, 27, null,
            14, 4, 14, 36, null,
             5, 0, 2.4, 20,  ]
  },]
}
